import {reactive, readonly, ref} from 'vue';

const allRecentlyAddedRowsById = reactive({});
const allRecentlyUpdatedRowsById = reactive({});
const allTimersForRecentlyUpdatedRows = reactive({});

export default function useTableRowHighlights(name: string) {
  if (!allRecentlyAddedRowsById[name]) {
    allRecentlyAddedRowsById[name] = new Set();
  }
  if (!allRecentlyUpdatedRowsById[name]) {
    allRecentlyUpdatedRowsById[name] = new Set();
  }
  if (!allTimersForRecentlyUpdatedRows[name]) {
    allTimersForRecentlyUpdatedRows[name] = new Map();
  }

  const recentlyAddedRowsById = allRecentlyAddedRowsById[name];
  const recentlyUpdatedRowsById = allRecentlyUpdatedRowsById[name];
  const timersForRecentlyUpdatedRows = allTimersForRecentlyUpdatedRows[name];

  const setRecentlyAddedId = (id: string) => {
    recentlyAddedRowsById.add(id);
  };

  const setRecentlyUpdatedId = (id: string) => {
    if (timersForRecentlyUpdatedRows.has(id)) {
      clearTimeout(timersForRecentlyUpdatedRows.get(id));
    }

    recentlyAddedRowsById.delete(id);

    // the animation is not triggered if the value is set immediately
    setTimeout(() => {
      recentlyUpdatedRowsById.add(id);
    }, 10);

    // Set a new timer to remove the id for the recently updated products
    const timer = setTimeout(() => {
      recentlyUpdatedRowsById.delete(id);
      timersForRecentlyUpdatedRows.delete(id);
    }, 3000);

    timersForRecentlyUpdatedRows.set(id, timer);
  };

  const clearRecentlyAddedIds = () => {
    recentlyAddedRowsById.clear();
  };
  const clearRecentlyUpdatedIds = () => {
    recentlyUpdatedRowsById.clear();
  };

  return {
    recentlyAddedRowsById: readonly(recentlyAddedRowsById),
    recentlyUpdatedRowsById: readonly(recentlyUpdatedRowsById),
    setRecentlyAddedId,
    setRecentlyUpdatedId,
    clearRecentlyAddedIds,
    clearRecentlyUpdatedIds,
  };
}
